export const expirationConfig = {
  families: 3600, // 1 hour
  onBoarding: 2592000, // 30 days
  banners:  1800, // 30 minutes
  stands: 86400, // 1 day
  products: 3600, // 1 hour
  favourites: 2592000 // 30 days
};
